export default __webpack_public_path__ + "static/media/fb.70ad3829.svg";